import { cva } from '@/styled-system/css';

export const containerRecipe = cva({
  base: {
    padding: '{spacing.600} {spacing.400}',
    border: '1px solid {colors.border.subtle}',
    borderRadius: '100',
    backgroundColor: 'bg.neutral',
  },
  variants: {
    isPremiumTip: {
      true: {
        borderTop: '3px solid {colors.border.accent.brand.hero}',
        width: { base: '100%', xl: '294px' },
      },
      false: {
        width: { base: '100%', md: '294px' },
      },
    },
  },
  defaultVariants: {
    isPremiumTip: false,
  },
});
